export default __webpack_public_path__ + "static/media/SALON.0667a2cd.jpg";